module.exports = __webpack_public_path__ + "static/media/5-Aquino(1).f4765525.png";